import { useNotificationToasts } from '@/hooks/useNotificationToasts';

export const NotificationToastProvider = ({ children }: { children: React.ReactNode }) => {
  useNotificationToasts();
  return <>{children}</>;
};